import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MobileWebViewService } from '@mpt-fo/common/core/services/mobile-web-view.service';

@Component({
	selector: 'app-mobile-app-version-upgrade',
	templateUrl: './mobile-app-version-upgrade.component.html',
	styleUrls: ['./mobile-app-version-upgrade.component.scss'],
})
export class MobileAppVersionUpgradeComponent implements OnInit {
	constructor(private router: Router, private mobileService: MobileWebViewService) {}

	ngOnInit(): void {}

	upgradeApp() {
		window.open(`${this.mobileService.APP_STORE_LINK}`, '_blank');
		this.router.navigateByUrl('/login');
	}
}
